// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"11794db6","410":"16177a8b","412":"6a739620"}[chunkId] + ".chunk.js";
};